<script>
import {
  required,requiredIf
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
    name: 'DeleteModal',
    props:[
      "routerList"
    ],
    data() {
        return {
              form: {
                type: '',
                mikrotik_delete:'',
                subscription_delete:''
              },
              submitted: false,
              blok: true,
              portList:[]
            };
    },
    validations: {
      form: {    
        router_id: {
          required: requiredIf(function () {
              return this.form.type == 'l'
          })
        },
        ip: { required },
        type: { required },
        subnet: { required },
      },
    },
    methods: {
        async destroy(subscription_delete = ''){
          const { router_id,port_id,mikrotik_delete} = this.form
            await this.$http.delete(`/ports?subscription_delete=${subscription_delete}&router_id=${router_id}&port_id=${port_id}&mikrotik_delete=${mikrotik_delete}`)
                .then(resp => {
                  if(resp.data.code !==  100)  return notify.error(resp.data.message)

                  this.portList = this.portList.filter((element) => element.id !== port_id);
                  this.$emit('loadItems')
                  return notify.success(resp.data.message)
                })
        },
        async getPorts({id}){
          let portList = []
          await this.$http.post('/ports/getByRouterId?groupBy=name', { routerId:id })
          .then(resp => {
              portList = resp.data
              portList.unshift({ id:'all',  name:'Tüm Hatlar'})
              this.portList = portList
            })
        },
        close(){
          this.$parent.$bvModal.hide('delete-ip')
        }
    },
};
</script> 

<template>
  <b-modal id="delete-ip" title="Hatları Sil/Boşalt"  no-close-on-backdrop hide-footer>
      <form @submit.prevent>
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="name">Mikrotik Seçiniz</label>
              <v-select 
                v-model="form.router_id"
                :filterable="false"
                :options="routerList"
                label="nasname"
                @option:selecting="getPorts($event)"
                :reduce="r => r.id">
                  <template slot="no-options">
                    Router ismi veya ip ile arayın
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                     {{ option.nasname }} - {{ option.shortname }}
                      </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.nasname }} - {{ option.shortname }}
                    </div>
                  </template>
              <span slot="no-options">Sonuç Bulunamadı</span>
              </v-select>
              <div
                v-if="submitted && !$v.form.router_id.required"
                class="invalid-feedback"
              >
                Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label for="name">Hat Adı</label>
              <v-select 
                  v-model="form.port_id"
                  :options="portList"
                  :reduce="r => r.id"
                  label="name"
                  >
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                      {{ option.name }} 
                        </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.name }} 
                      </div>
                    </template>
                <span slot="no-options">Sonuç Bulunamadı</span>
              </v-select>
              <div
                v-if="submitted && !$v.form.port_id.required"
                class="invalid-feedback"
              >
                Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="form.mikrotik_delete" value="1" id="flexCheckDefault">
              <label class="form-check-label" for="flexCheckDefault">
                Mikrotiktede Aynı İşlemi Yap
              </label>
            </div>
          </div>
          <div v-if="form.mikrotik_delete">
              <div class="alert alert-warning">Mikrotiklere <strong>api</strong> bağlantısının sorunsuz bir şekilde erişebiliyor olması gerekmetedir.</div>
          </div>
        </div>
         <div class="mt-3">
         <b-button 
            type="submit" 
            block
            variant="danger" 
            class="ms-1"
            @click="destroy()"
            >Seçilen Tüm Hatları Sil
          </b-button> 
        </div>
        <div class="d-flex justify-content-between mt-3"> 
          <b-button 
            type="submit" 
            block
            variant="danger" 
            @click="destroy(1)"
            class="ms-1"
            >Seçilen Tüm Hatlardaki Müşterileri Boşa Çıkar
          </b-button>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
        </div>
      </form>
    </b-modal>
</template>